module.exports = __webpack_public_path__ + "img/Darla_Magnani.76270f10.jpeg";